module.exports = {
  variant: {
    background: { base: 'color.white' },
  },
};
